// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import settingsEN from "./locales/en/settings.json";
import settingsSV from "./locales/sv/settings.json";
import voyageselectEN from "./locales/en/voyageselect.json";
import voyageselectSV from "./locales/sv/voyageselect.json";
import loginEN from "./locales/en/login.json";
import loginSV from "./locales/sv/login.json";
import currentvoyageEN from "./locales/en/currentvoyage.json";
import currentvoyageSV from "./locales/sv/currentvoyage.json";
import statementoffactEN from "./locales/en/statementoffact.json";
import statementoffactSV from "./locales/sv/statementoffact.json";
import noticeofreadinessEN from "./locales/en/noticeofreadiness.json";
import noticeofreadinessSV from "./locales/sv/noticeofreadiness.json";
import tankcertEN from "./locales/en/tankcert.json";
import tankcertSV from "./locales/sv/tankcert.json";
import receivingcapacitystatementEN from "./locales/en/receivingcapacitystatement.json";
import receivingcapacitystatementSV from "./locales/sv/receivingcapacitystatement.json";
import slopEN from "./locales/en/slop.json";
import slopSV from "./locales/sv/slop.json";
import pumpstatementEN from "./locales/en/pumpstatement.json";
import pumpstatementSV from "./locales/sv/pumpstatement.json";
import loggingEN from "./locales/en/logging.json";
import loggingSV from "./locales/sv/logging.json";
import obqrobEN from "./locales/en/obqrob.json";
import obqrobSV from "./locales/sv/obqrob.json";
import vefEN from "./locales/en/vef.json";
import vefSV from "./locales/sv/vef.json";

const resources = {
  en: {
    settings: settingsEN,
    voyageselect: voyageselectEN,
    login: loginEN,
    currentvoyage: currentvoyageEN,
    statementoffact: statementoffactEN,
    noticeofreadiness: noticeofreadinessEN,
    tankcert: tankcertEN,
    receivingcapacitystatement: receivingcapacitystatementEN,
    slop: slopEN,
    pumpstatement: pumpstatementEN,
    logging: loggingEN,
    obqrob: obqrobEN,
    vef: vefEN,
  },
  sv: {
    settings: settingsSV,
    voyageselect: voyageselectSV,
    login: loginSV,
    currentvoyage: currentvoyageSV,
    statementoffact: statementoffactSV,
    noticeofreadiness: noticeofreadinessSV,
    tankcert: tankcertSV,
    receivingcapacitystatement: receivingcapacitystatementSV,
    slop: slopSV,
    pumpstatement: pumpstatementSV,
    logging: loggingSV,
    obqrob: obqrobSV,
    vef: vefSV,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "sv",
  fallbackLng: "en",
  ns: ["settings"], // namespaces
  defaultNS: "settings",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
